import api from 'api'

export interface TopupConfig {
  // Money values are dollars, serialized as strings by the backend.
  minTopupThreshold: string
  forecastBufferAmount: string
  forecastLookaheadDays: number
  actorId: number
  actorName: string | null
  configuredAt: string
}

export interface TopupConfigUpdate {
  // Money values are dollars; sent as strings to preserve decimal precision.
  minTopupThreshold: string
  forecastBufferAmount: string
  forecastLookaheadDays: number
}

export async function getTopupConfig(): Promise<TopupConfig> {
  const resp = await api.get<TopupConfig>('/admin/highnote/topup/config')
  return resp.data
}

export async function updateTopupConfig(
  update: TopupConfigUpdate
): Promise<TopupConfig> {
  const resp = await api.post<TopupConfig>(
    '/admin/highnote/topup/config',
    update
  )
  return resp.data
}
